<template>
<div></div>
</template>

<script>
export default {
  name: 'BarChart'
};
</script>